<script lang="ts">
	import { RectangularAvatar } from '@Shelly/shelly-design-system';

	export interface Home {
		id: string;
		name: string;
		avatar?: {
			image?: string;
			text?: string;
			backgroundColor?: string;
		};
	}

	const HOME_ICON = 'fa-solid fa-house-chimney';

	interface Props {
		home?: Home;
		size?: 's' | 'm' | 'l';
	}

	let { home, size = 's', ...rest }: Props = $props();
</script>

<RectangularAvatar
	{...rest}
	{size}
	icon={home?.avatar === undefined ? HOME_ICON : undefined}
	image={home?.avatar === undefined ? undefined : home?.avatar?.image}
	defaultImageIcon={HOME_ICON}
	text={home?.avatar?.text || home?.name?.charAt(0)}
	backgroundColor={home?.avatar?.backgroundColor}
/>
